import { combineReducers } from 'redux'

import search from './searchReducer'
import coverage from './coverageReducer'
import purchase from './purchaseReducer'
import comparison from './comparisonReducer'
import purchaseStatus from './purchaseStatusReducer'
import mobile from './mobileReducer'
import global from './globalReducer'

export default combineReducers({
    search,
    comparison,
    coverage,
    purchase,
    purchaseStatus,
    mobile,
    global,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js